angular.module('impactx.approval').controller('CateringApprovalCtrl', CateringApprovalCtrl);

CateringApprovalCtrl.$inject = ['$scope', 'dataGen', '$routeParams', 'ToolbarService', 'BackService', 'ToastService', 'TranslationService'];

function CateringApprovalCtrl($scope, dataGen, $routeParams, ToolbarService, BackService, ToastService, TranslationService) {
    var ctrl = this;

    var atiId = $routeParams.id

    $scope.showComments = {value: false};
    $scope.selectedItems = [];
    $scope.hasChanged = false;

    ctrl.addParticipant = function () {
        $scope.data.participants.push({selected: {value: null}});
    };

    ctrl.removeParticipant = function (index) {
        $scope.data.participants.splice(index, 1);
    };

    ctrl.participantSearchTextChange = function (index, selected, searchText) {
        if (!$scope.data.participants[index].freeSelection) {
            $scope.data.participants[index].freeSelection = {value: null};
        }
        if (!selected) {
            $scope.data.participants[index].freeSelection.value = searchText;
        }
        else {
            $scope.data.participants[index].freeSelection.value = null;
        }
    };

    ctrl.participantSelect = function (index, selected, baseObject, searchText) {
        if (!$scope.data.participants[index].freeSelection) {
            $scope.data.participants[index].freeSelection = {value: null};
        }
        if (!selected) {
            $scope.data.participants[index].freeSelection.value = searchText;
        }
        else {
            $scope.data.participants[index].freeSelection.value = null;
        }
    };

    ctrl.markAsChanged = function (item) {
        var isValid;
        if (item) {
            isValid = impactX.isDefined($scope, 'dialogData.itemAmount' + item.id + '.$valid');
            if (isValid !== undefined) {
                $scope.hasChanged = isValid;
            }
            else {
                $scope.hasChanged = true;
            }
        }
        else {
            isValid = impactX.isDefined($scope, 'dialogData.singleNetPrice.$valid');
            if (isValid !== undefined) {
                $scope.hasChanged = isValid;
            }
            else {
                $scope.hasChanged = true;
            }
        }
    };

    ctrl.getData = function () {
        var paramObj = {
            atiId: atiId
        };
        dataGen.getData($scope, paramObj, '/approval/editcatering').then(function () {
            // some default / placeholder data
            if($scope.data.participants.length === 0) {
                ctrl.addParticipant();
            }
            $scope.data.timePeriod.value = $scope.data.timePeriod.value || '-'
            $scope.data.placeOfDelivery.value = $scope.data.placeOfDelivery.value || '-'
            $scope.data.timeOfDelivery.value = $scope.data.timeOfDelivery.value || '-'
            defineButtons();
            // recreate selection after refresh
            var selectedItems = $scope.selectedItems;
            $scope.selectedItems = [];
            angular.forEach($scope.data.orderedMenu, function (item) {
                var wasSelected = selectedItems.filter(function (entry) {
                    return item.id === entry.id;
                }).length > 0;
                if (wasSelected) {
                    item.selected = true;
                    $scope.selectedItems.push(item);
                }
            });
            $scope.hasChanged = false;
        });
    };

    ctrl.refresh = function () {
        var paramObj = {
            cateringData: $scope.data
        };
        dataGen.postAsForm({}, paramObj, '/approval/refreshcatering').then(function () {
            ctrl.getData()
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    var saveInternal = function () {
        var paramObj = {
            cateringData: $scope.data
        };
        return dataGen.postAsForm({}, paramObj, '/approval/savecatering');
    };

    ctrl.save = function () {
        return saveInternal().then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'))
        });
    };

    ctrl.approve = function () {
        var dataObj = {
            cateringData: $scope.data
        };
        return dataGen.postAsForm({}, dataObj, "/approval/approve/catering").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'))
        });
    };

    ctrl.deny = function () {
        var dataObj = {
            cateringData: $scope.data
        };
        return dataGen.postAsForm({}, dataObj, "/approval/deny/catering").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'))
        });
    };

    ctrl.toggleComments = function () {
        $scope.showComments.value = !$scope.showComments.value;
    };

    ctrl.disableSave = function () {
        return impactX.isDefined($scope, 'data.comments.internalComments.attachmentRequired.value');
    };

    var mainView = angular.element("#main-content");
    mainView.bind("scroll", function () {
        ctrl.updateButton();
    });

    ctrl.updateButton = function () {
        if ($scope.hasChanged) {
            var summaryElement = angular.element('#basket-summary');
            var stickyButtonElement = angular.element('#stickyRefreshButton');

            var middle = (summaryElement.offset().top + summaryElement.height());
            if (middle < (mainView.offset().top + mainView.height())) {
                stickyButtonElement.css({
                    "position": "absolute",
                    "bottom": "",
                    "right": "24px",
                    "top": "30%"
                });
            }
            else {
                stickyButtonElement.css({
                    "position": "fixed",
                    "bottom": "32px",
                    "right": "48px",
                    "top": ""
                });
            }
        }
    };

    ctrl.getData();

    ctrl.canView = function() {
        return $scope.data.hasRightToView;
    };

    ctrl.view = function () {
        var dataObj = {
            data: {
                PRH_Id: $scope.data.prhId,
                CSC_Id: $scope.data.cscId,
                type: "prs",
                id: $scope.data.atiId
            }
        };

        return dataGen.postAsForm($scope, dataObj, "/approval/approvalview").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'))
        });
    };

    function defineButtons() {
        var buttonDefinition = [];
        if (!$scope.data.readOnly) {
            buttonDefinition = [
                {
                    label: $scope.trns.save,
                    action: ctrl.save,
                    type: 'validation',
                    params: {
                        form: $scope.dialogData,
                        disableExpression: {
                            valueFunction: ctrl.disableSave,
                            error: $scope.trns.needReceipt
                        }
                    }
                },
                {
                    label: $scope.trns.approve,
                    action: ctrl.approve,
                    type: 'validation',
                    params: {
                        form: $scope.dialogData,
                        disableExpression: {
                            valueFunction: ctrl.disableSave,
                            error: $scope.trns.needReceipt
                        }
                    }
                },
                {
                    label: $scope.trns.deny,
                    action: ctrl.deny,
                    type: 'dialogaction'
                },
                {
                    label: $scope.trns.comments,
                    action: ctrl.toggleComments,
                    type: 'dialogaction'
                }
            ];
        }
        else {
            buttonDefinition = [
                {
                    label: $scope.trns.viewed,
                    action: ctrl.view,
                    type: 'dialogaction',
                    condition: ctrl.canView
                }
            ];
        }
        ToolbarService.setButtons(buttonDefinition);
    }
}